import { render } from "preact";
import { Boot } from "./ui/boot";
import "./ui/base.css";

const root = document.getElementById("app");
if (!root) throw new Error("#app missing");
render(<Boot />, root);
